module.exports = __webpack_public_path__ + "img/service-5.788830f5.png";